module.exports = __webpack_public_path__ + "static/media/line-red.a48be8dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/line-red.svg
// module id = 773
// module chunks = 0